<template>
  <div class="faq">
    <page-title :page="page" />
    <Breadcrumb :items="breadcrumb" />
    <v-container class="relative">
      <v-row>
        <v-col cols="0" md="3" v-if="!$vuetify.breakpoint.mobile">
          <h2 class="faq-title">FILTRA LE FAQ PER:</h2>
          <FaqCategory />
          <v-divider class="my-5"></v-divider>
          <SupportCard />
        </v-col>
        <v-col cols="12" md="9" class="position-relative">
          <div v-if="faqData">
            <v-expansion-panels class="faq-list" accordion flat>
              <v-expansion-panel
                v-for="item in faqData"
                :key="item.id"
                class="mb-1"
              >
                <v-expansion-panel-header class="secondary lighten-1">
                  <h3 v-html="item.title.rendered" @click="clicked"></h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.content.rendered" @click="clicked"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-speed-dial
            v-if="$vuetify.breakpoint.mobile"
            v-model="fab"
            :right="true"
            :bottom="true"
            absolute
            direction="left"
            transition="slide-y-reverse-transition"
            class="faq-filter"
          >
            <template v-slot:activator>
              <v-btn v-model="fab" color="primary" fab>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-tune-variant
                </v-icon>
              </v-btn>
            </template>
            <v-card><FaqCategory /> </v-card>
          </v-speed-dial>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped lang="scss">
.faq-title {
  font-size: 13px;
  color: $primary;
}
.position-relative {
  position: relative;
}
.faq-list {
  .v-expansion-panel-header {
    color: var(--v-secondary-base) !important;
  }
}
.faq-filter {
  .v-speed-dial__list {
    min-width: 400px;
    left: initial;
    right: 0;
  }
}
</style>
<script>
import FaqCategory from "@/components/wordpress/FaqCategory";
import SupportCard from "@/components/cards/SupportCard";
import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
import CMSService from "~/service/cmService";
import page from "~/mixins/page";
import clickHandler from "~/mixins/clickHandler";

import PageTitle from "@/components/wordpress/PageTitle.vue";
export default {
  name: "FaqList",
  components: { FaqCategory, Breadcrumb, SupportCard, PageTitle },
  data() {
    return {
      faqData: null,
      fab: false
    };
  },
  mixins: [page, clickHandler],
  mounted() {
    this.fetchFaqList(this.$route.params.categoryName);
    // this.fetchPage("faq");
    this.page = this.$route.params.page;
  },
  methods: {
    async fetchFaqList(categoryName) {
      let res = await CMSService.getCustomPostByFilters("faq", [
        {
          filterName: "filter[categoria_faq]",
          filterValue: categoryName
        }
      ]);

      this.faqData = res.data;
    }
  },
  watch: {
    "$route.params.categoryName": function(categoryName) {
      this.fetchFaqList(categoryName);
    }
  }
};
</script>
